import { render, staticRenderFns } from "./PopupTerms.vue?vue&type=template&id=99ca9344&"
import script from "./PopupTerms.vue?vue&type=script&lang=js&"
export * from "./PopupTerms.vue?vue&type=script&lang=js&"
import style0 from "./PopupTerms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports